import React, { useMemo, useState } from "react";
import { Segmented, ConfigProvider, Button, theme as antdTheme, Tooltip, Modal, Radio } from "antd";
import { Helmet } from "react-helmet-async";
import { FolderOutput, Funnel, Menu, Wallet } from "lucide-react";


import Layout from '../../Layout';
import RevenuePlan from "./components/RevenuePlan";
import ExpensePlan from "./components/ExpensePlan";
import CashFlowPlan from "./components/CashFlowPlan";
import './style.scss'

type View = "quarter" | "month";

const tabs = [
  { id: 'expense', label: 'Kế hoạch thu' },
  { id: 'revenue', label: 'Kế hoạch chi' },
  { id: 'money', label: 'Dòng tiền' },

]

export default function Budget() {
  const [dark, setDark] = useState(false);
  const [tab, setTab] = useState('expense')
  const [showModalView, setShowModalView] = useState(false)

  const [view, setView] = useState<View>("month");
  // State tạm lưu giá trị khi chọn Radio trong Modal
  const [tempView, setTempView] = useState<View>("quarter");

  // Mở modal và đồng bộ state tạm
  const handleOpenModal = () => {
    setTempView(view);
    setShowModalView(true);
  };

  // Áp dụng cập nhật và đóng Modal
  const handleApply = () => {
    setView(tempView);
    setShowModalView(false);
  };

  return (
    <Layout>
      <Helmet>
        <title>Ngân sách | Khothi</title>
      </Helmet>
      <ConfigProvider
        theme={{
          algorithm: dark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
          token: { colorPrimary: "#0d9488", borderRadius: 8 },
        }}
      >
        <div className="budget-page min-h-screen text-slate-900 dark:text-slate-100 transition-colors">
          <div className="mx-auto py-6 sm:py-8">
            {/* --- HEADER ACTIONS --- */}
            <div className="text-sm border-b dark:border-gray-700 px-4 md:px-6 py-3 flex flex-wrap justify-between items-center gap-4 sticky top-[64px] bg-white dark:bg-[#1f1f1f] z-10 shadow-sm">

              <div className='overflow-x-auto no-scrollbar'>
                <div className="flex items-center gap-4 xl:gap-5 w-full xl:w-auto ml-auto min-w-max text-000000e0">
                  <Menu size={14} />
                  {tabs.map((item) => (
                    <button
                      type="button"
                      onClick={() => setTab(item.id)}
                      className={`font-medium pb-1 border-b-2 transition-colors ${item.id === tab
                        ? "text-[#3e91ab] border-[#3e91ab]"
                        : "text-gray-500 dark:text-gray-400 border-transparent"
                        }`}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className='overflow-x-auto no-scrollbar'>
                <div className="flex items-center gap-4 xl:gap-5 w-full xl:w-auto ml-auto min-w-max">
                  <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <Wallet size={14} className="mr-1.5 text-gray-400" /> Xem thêm</button>
                  <button onClick={handleOpenModal} className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <Wallet size={14} className="mr-1.5 text-gray-400" /> Hiển thị</button>
                  <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <Funnel size={14} className="mr-1.5 text-gray-400" /> Bộ lọc</button>
                  <button className="flex items-center text-xs text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"> <FolderOutput size={14} className="mr-1.5 text-gray-400" /> Export</button>

                </div>
              </div>
            </div>
            <div>
              {tab === 'expense' && (
                <ExpensePlan view={view} />
              )}

              {tab === 'revenue' && (
                <RevenuePlan view={view} />
              )}

              {tab === 'money' && (
                <CashFlowPlan view={view} />
              )}

            </div>

            {/* MODAL */}
            <Modal
              open={showModalView}
              title={<span className="text-gray-800 dark:text-gray-200 text-sm font-medium">Hiển thị</span>}
              onCancel={() => setShowModalView(false)}
              width={280}
              footer={[
                <Button
                  onClick={handleApply}
                  type="primary"
                  className="px-5 py-2.5 text-white font-medium rounded-md text-xs transition-colors"
                >
                  CẬP NHẬT
                </Button>
              ]}
            >
              <div className="py-4">
                <p className="text-gray-700 dark:text-gray-200 mb-4 text-base">Xem theo</p>

                <Radio.Group
                  className="flex items-center gap-8"
                  onChange={(e) => setTempView(e.target.value)}
                  value={tempView}
                >
                  <Radio value="month" className="text-base">
                    Năm
                  </Radio>
                  <Radio value="quarter" className="text-base">
                    Quý
                  </Radio>
                </Radio.Group>
              </div>
            </Modal>
          </div>
        </div>
      </ConfigProvider>
    </Layout>
  );
}